{
  "strict": {
    "text-font-family": "Roboto-Medium",
    "text-heading-6-font-family": "Roboto-Bold",
    "text-paragraph-1-font-family": "Roboto-Regular",
    "text-caption-1-font-family": "Roboto-Light"
  },
  "components": {
    "Button": {
      "appearances": {
        "outline": {
          "mapping": {},
          "variantGroups": {
            "status": {
              "primary": {
                "backgroundColor": "white",
                "textColor": "black",
                "state": {
                  "hover": {
                    "backgroundColor": "white"
                  },
                  "active": {
                    "backgroundColor": "white"
                  },
                  "focused": {
                    "backgroundColor": "white"
                  }
                }
              }
            }
          }
        }
      }
    },
    "Datepicker": {
      "appearances": {
        "default": {
          "variantGroups": {
            "status": {
              "basic": {
                "backgroundColor": "transparent"
              }
            },
            "size": {
              "medium": {
                "minHeight": "size-medium",
                "borderRadius": 8,
                "borderWidth": 2,
                "paddingVertical": 7,
                "textFontSize": "text-subtitle-1-font-size",
                "textFontWeight": "normal"
              }
            }
          }
        }
      }
    },
    "Select": {
      "appearances": {
        "default": {
          "variantGroups": {
            "status": {
              "basic": {
                "borderColor": "rgb(158, 158, 158)",
                "backgroundColor": "white",
                "textColor": "black",
                "labelColor": "rgb(102, 102, 102)",
                "captionColor": "black",
                "placeholderColor": "rgb(102, 102, 102)",
                "iconTintColor": "rgb(102, 102, 102)",
                "state": {
                  "focused": {
                    "backgroundColor": "white"
                  },
                  "hover": {
                    "borderColor": "black",
                    "backgroundColor": "white"
                  },
                  "active": {
                    "backgroundColor": "white"
                  }
                }
              }
            }
          }
        }
      }
    },
    "SelectOption": {
      "appearances": {
        "default": {
          "mapping": {
            "textFontWeight": "400",
            "textColor": "black",
            "state": {
              "hover": {
                "backgroundColor": "rgb(246, 246, 246)"
              },
              "selected": {
                "backgroundColor": "rgb(219, 231, 245)"
              }
            }
          }
        }
      }
    }
  }
}
